import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Store from '@happenings/components/store';
import { getPostData } from '@happenings/components/post';

import PostContainer from './PostContainer';
import InteractionButtons from './InteractionButtons';

/**
 * Publically viewable Event page, don't need to be signed in. Will redirect to
 * public landing if 'like' or 'attend' is clicked with no signed in user.
 */

const PostPage = () => {
  const { event_id } = useParams<{ event_id: string }>();
  const post = useSelector((state: Store) => state.entities.posts[event_id]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (event_id) {
      dispatch(getPostData(parseInt(event_id, 10)));
    }
  }, [dispatch, event_id]);

  if (!post) return null;

  return (
    <div>
      <PostContainer id={post.id} post={post} />
      <InteractionButtons postId={post.id} />
    </div>
  );
};

export default PostPage;
